@if (ConstsHelper.FAQS[this.faq] && ConstsHelper.FAQS[this.faq].length > 0) {
    <div class="frequently-questions-area">
        <div [className]="'hr-'+environment.data.brand"></div>
        <h2>Questions fréquentes</h2>
        <div class="questions">
            <ul>
                @for (question of ConstsHelper.FAQS[this.faq]; track question) {
                    <li [id]="question.id ? question.id : ''">
                        <a [innerHTML]="question.value" (click)="openFaqContent($event)"></a>
                        <div style="display: none;" [innerHTML]="sanitizeContent(question.content)"></div>
                    </li>
                }
            </ul>
        </div>
    </div>
}
